import { ROUTER_NAMES, ROUTER_PATHS } from "@/constants/router.constants"
import { LoginLayout } from "@/layouts"

const LoginRegister = () =>
  import(/* webpackChunkName: "authentication" */ "@/pages/LoginRegister")
const LoginForm = () =>
  import(/* webpackChunkName: "authentication" */ "@/components/LoginForm")
const RegisterForm = () =>
  import(/* webpackChunkName: "authentication" */ "@/components/RegisterForm")
const ForgotPasswordForm = () =>
  import(
    /* webpackChunkName: "authentication" */ "@/components/ForgotPasswordForm"
  )
const OauthApproveForm = () =>
  import(
    /* webpackChunkName: "authentication" */ "@/components/auth/OauthApproveForm"
  )

export default [
  {
    path: ROUTER_PATHS.LOGIN,
    alias: [ROUTER_PATHS.OAUTH_LOGIN],
    name: ROUTER_NAMES.LOGIN,
    component: LoginRegister,
    props: {
      form: LoginForm,
    },
    meta: {
      layout: {
        component: LoginLayout,
      },
    },
  },
  {
    path: "/forgot-password/",
    name: ROUTER_NAMES.FORGOT_PASSWORD,
    component: LoginRegister,
    props: {
      form: ForgotPasswordForm,
    },
    meta: {
      layout: {
        component: LoginLayout,
      },
    },
  },
  {
    path: "/register/",
    name: ROUTER_NAMES.REGISTER,
    component: LoginRegister,
    props: {
      form: RegisterForm,
    },
    meta: {
      layout: {
        component: LoginLayout,
      },
    },
  },
  {
    path: ROUTER_PATHS.OAUTH_APPROVE,
    name: ROUTER_NAMES.OAUTH_APPROVE,
    component: LoginRegister,
    props: {
      form: OauthApproveForm,
    },
    meta: {
      layout: {
        component: LoginLayout,
      },
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/auth.routes.js